var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BaseFilePreview } from '../base-file-preview';
var PdfPreviewComponent = /** @class */ (function (_super) {
    __extends(PdfPreviewComponent, _super);
    function PdfPreviewComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.className = 'preview-object';
        return _this;
    }
    return PdfPreviewComponent;
}(BaseFilePreview));
export { PdfPreviewComponent };
